module.exports = __webpack_public_path__ + "img/xmas_3point.665accdd.png";